"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = require("@CommonFrontendBackend/FeatureFlag");
exports.default = (function (usingFeature) {
    return function (project) {
        return ((!usingFeature(FeatureFlag_1.FeatureFlag.Quote) && project.quoteBlockCount > 0) ||
            (!usingFeature(FeatureFlag_1.FeatureFlag.Accept) && project.hasAcceptEnabled));
    };
});
